import {SVGProps} from "react";

// Rules & policies shield from the V2 footer (Figma "Icon / shield", 78:916).
export const ShieldCheckSvg = ({color = '#E4BD79', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path
            d="M10.5 2.625L3.5 5.25V10.5C3.5 14.875 10.5 18.375 10.5 18.375C10.5 18.375 17.5 14.875 17.5 10.5V5.25L10.5 2.625Z"
            stroke={color} strokeWidth="1.4875" strokeLinejoin="round"/>
        <path d="M7.4375 10.5L9.625 12.6875L13.5625 8.3125" stroke={color} strokeWidth="1.4875" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>
)
